import React from 'react';
import { AnnouncementBar } from './components/AnnouncementBar';
import { Hero } from './components/Hero';
import { PsychologySection } from './components/PsychologySection';
import { IndustrySection } from './components/IndustrySection';
import { ProductPresentation } from './components/ProductPresentation';
import { SocialProof } from './components/SocialProof';
import { ValueStack } from './components/ValueStack';
import { Guarantee } from './components/Guarantee';
import { PaymentBadges } from './components/PaymentBadges';
import { Footer } from './components/Footer';
import { LivePurchaseNotification } from './components/LivePurchaseNotification';
export function App() {
  return <div className="min-h-screen bg-dark text-white selection:bg-gold/30 selection:text-white" data-id="element-0">
      <AnnouncementBar data-id="element-1" />
      <main data-id="element-2">
        <Hero data-id="element-3" />
        <PsychologySection data-id="element-4" />
        <IndustrySection data-id="element-5" />
        <ProductPresentation data-id="element-6" />
        <SocialProof data-id="element-7" />
        <ValueStack data-id="element-8" />
        <Guarantee data-id="element-9" />
        <PaymentBadges data-id="element-10" />
      </main>
      <Footer data-id="element-11" />
      <LivePurchaseNotification data-id="element-12" />
    </div>;
}